import type { DeliveryDiscountType } from '../enums/DeliveryDiscountType'
import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'
import type { DiscountTypeForDeliveryDiscount } from '../enums/DiscountType'

export class DeliveryDiscountEntity {
  id?: string
  name?: string | null
  type?: DeliveryDiscountType
  priority?: number | null
  startDate?: string | null
  endDate?: string | null
  isActive?: boolean
  ignoreDaysCheck?: boolean
  segments?: Array<DeliveryDiscountSegmentEntity> | null
  days?: Array<DeliveryDiscountDayEntity> | null
}

export class DeliveryDiscountSegmentEntity {
  id?: string
  shareType?: string
  from?: number
  to?: number
  discountValue?: number
  discountType?: DiscountTypeForDeliveryDiscount
  serviceRatio?: number | null
  branchRatio?: number | null
  limitedBranchShareAmount?: number | null
}

export class DeliveryDiscountDayEntity {
  id?: string
  dayOfWeek?: DayOfWeek
  periods?: Array<DeliveryDiscountPeriodEntity> | null
}

export class DeliveryDiscountPeriodEntity {
  id?: string
  startTime?: string
  startTimeDayOfWeek?: DayOfWeek
  endTime?: string
  endTimeDayOfWeek?: DayOfWeek
}
